export default "__VITE_PUBLIC_ASSET__d016ecfb__"